// extracted by mini-css-extract-plugin
export default {"NewGrey":"#596067","steps":"Gf38747 G1b0730"};